import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, ArrowRight, Calendar } from 'lucide-react';
import ClientPageLayout from '../../components/shared/layouts/ClientPageLayout';

/**
 * Card details are not stored on vendaList — payments run through Stripe checkout
 * at booking/invoice time. This page is intentionally light until saved methods exist.
 */
const ClientBilling = () => {
  return (
    <ClientPageLayout
      title="Billing"
      subtitle="Payments are processed securely through Stripe when you book or pay an invoice."
      guideKey="billing"
    >
      <div className="space-y-5">
        <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-6 sm:p-8">
          <div className="flex flex-col sm:flex-row sm:items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-sky-50 dark:bg-sky-950/40 border border-sky-100 dark:border-sky-800 flex items-center justify-center flex-shrink-0">
              <CreditCard className="w-6 h-6 text-sky-700 dark:text-sky-300" />
            </div>
            <div className="min-w-0 flex-1">
              <h2 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-gray-50">
                No saved payment methods
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1.5 leading-relaxed max-w-xl">
                We don’t store card details on your account. When you pay a deposit or invoice,
                Stripe handles the payment securely. Your booking history and receipts stay under
                My Bookings.
              </p>
              <Link
                to="/bookings"
                className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 bg-primary-600 text-white text-sm font-medium !rounded-xl hover:bg-primary-700 transition-colors"
              >
                <Calendar className="w-4 h-4" />
                Go to My Bookings
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </ClientPageLayout>
  );
};

export default ClientBilling;
